import { render } from "./SearchHotelsView.vue?vue&type=template&id=a639f910&scoped=true&ts=true"
import script from "./SearchHotelsView.vue?vue&type=script&lang=ts"
export * from "./SearchHotelsView.vue?vue&type=script&lang=ts"

import "./SearchHotelsView.vue?vue&type=style&index=0&id=a639f910&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a639f910"]])

export default __exports__